export const taskTemplatesEn = {
  title: 'Task templates',
  createTemplate: 'Create',
  settingsTemplate: 'Customize',
  createFromExistTask: 'From existing task',
  backToList: 'Back to templates list',
  createTitle: 'Creating a new template',
  templateName: 'Template name',
  titleAuthor: 'Authors and executors',
  executors: 'Executors',
  responsible: 'Responsible',
  stickers: 'Stickers',
  description: 'Description',

  existenceTitle: 'Creating from existence task',
  editDescription: 'Edit description',
  subtasks: 'Subtasks',
  createSubTask: 'Create subtask',
  checklist: 'Checklist',

  subscribers: 'Chat members',

  editTitle: (title: string) => `Edit the template “${title}”`,
  createTitlePlaceholder: 'Enter the template name',
  messageDeleteConfirm: 'Delete this template?',
  createButton: 'Create Template',
  saveButton: 'Save',
  emptyText1: "For now, it's empty.",
  emptyText2: 'Create task templates on the board to save your time.',
  deadlineHint:
    'The deadline is specified from the current date. When creating a task using a template, it will be shifted.',
  descTitlePlaceholder: 'Task template name',
  onSubmitEmptyTitle: 'Enter a name for the task template'
}

export const taskTemplatesRu: typeof taskTemplatesEn = {
  title: 'Шаблоны задач',
  createTemplate: 'Создать',
  settingsTemplate: 'Настроить',
  createFromExistTask: 'Из существующей задачи',
  backToList: 'Назад к списку шаблонов',
  createTitle: 'Создание нового шаблона',
  templateName: 'Название шаблона',
  titleAuthor: 'Авторы и исполнители',
  executors: 'Исполнители',
  responsible: 'Ответственный',
  stickers: 'Стикеры',
  description: 'Описание',
  subtasks: 'Подзадачи',
  subscribers: 'Участники чата',

  checklist: 'Чеклисты',
  createSubTask: 'Создать подзадачу',
  editDescription: 'Редактировать описание',
  existenceTitle: 'Создание из существующей задачи',
  editTitle: (title: string) => `Редактирование шаблона “${title}”`,
  createTitlePlaceholder: 'Введите название шаблона',
  messageDeleteConfirm: 'Удалить шаблон задачи?',
  createButton: 'Создать шаблон',
  saveButton: 'Сохранить',
  emptyText1: 'Пока здесь пусто.',
  emptyText2: 'Создайте на доске шаблоны задач для экономии своего времени.',
  deadlineHint:
    'Дедлайн указывается от текущей даты. При создании задачи по шаблону он будет смещён.',
  descTitlePlaceholder: 'Название шаблона задачи',
  onSubmitEmptyTitle: 'Введите имя шаблона задачи'
}
